import { Link } from "react-router-dom";
import { LegalLayout, Clause, Bi, BiList, ORG_NAME } from "./LegalLayout";

export default function PrivacyPolicyPage() {
  return (
    <LegalLayout
      title="Privacy Policy"
      titleBn="প্রাইভেসি নীতিমালা"
      intro={
        <Bi
          en={
            <>
              {ORG_NAME} (&ldquo;we&rdquo;, &ldquo;us&rdquo;, &ldquo;our&rdquo;) respects your privacy
              and is committed to protecting your personal data. This Privacy Policy explains what
              information we collect, how we use and protect it, and the rights you have. It applies
              to our website, applications and services, and should be read together with our{" "}
              <Link to="/terms" className="text-primary underline underline-offset-2">Terms &amp; Conditions</Link>.
            </>
          }
          bn={
            <>
              {ORG_NAME} (&ldquo;আমরা&rdquo;) আপনার গোপনীয়তাকে সম্মান করে এবং আপনার ব্যক্তিগত তথ্য সুরক্ষায়
              প্রতিশ্রুতিবদ্ধ। এই প্রাইভেসি নীতিমালায় আমরা কী তথ্য সংগ্রহ করি, কীভাবে তা ব্যবহার ও সুরক্ষা করি এবং
              আপনার কী অধিকার রয়েছে তা ব্যাখ্যা করা হয়েছে। এটি আমাদের ওয়েবসাইট, অ্যাপ্লিকেশন ও সেবার ক্ষেত্রে
              প্রযোজ্য এবং আমাদের{" "}
              <Link to="/terms" className="text-primary underline underline-offset-2">শর্তাবলির</Link> সাথে একত্রে পাঠ্য।
            </>
          }
        />
      }
    >
      <Clause n="1" title="Information We Collect" titleBn="আমরা যে তথ্য সংগ্রহ করি">
        <BiList
          items={[
            [
              "Account & identity data: your name, email address, mobile number and password.",
              "অ্যাকাউন্ট ও পরিচয় তথ্য: নাম, ইমেইল, মোবাইল নম্বর ও পাসওয়ার্ড।",
            ],
            [
              "Profile data: profile picture and any details you choose to add.",
              "প্রোফাইল তথ্য: প্রোফাইল ছবি ও আপনার যোগ করা অন্যান্য তথ্য।",
            ],
            [
              "Learning data: courses purchased, progress, exam and mock test results, and certificates.",
              "শিক্ষা তথ্য: ক্রয়কৃত কোর্স, অগ্রগতি, পরীক্ষা ও মক টেস্টের ফলাফল এবং সার্টিফিকেট।",
            ],
            [
              "Payment data: transaction records and references from bKash and other payment providers. We do NOT store your bKash PIN, full card numbers or banking passwords.",
              "পেমেন্ট তথ্য: বিকাশ ও অন্যান্য পেমেন্ট প্রদানকারীর লেনদেন রেকর্ড ও রেফারেন্স। আমরা আপনার বিকাশ পিন, সম্পূর্ণ কার্ড নম্বর বা ব্যাংকিং পাসওয়ার্ড সংরক্ষণ করি না।",
            ],
            [
              "Technical data: IP address, device and browser type, and usage logs collected automatically.",
              "কারিগরি তথ্য: আইপি ঠিকানা, ডিভাইস ও ব্রাউজারের ধরন এবং স্বয়ংক্রিয়ভাবে সংগৃহীত ব্যবহার-লগ।",
            ],
            [
              "Communications: messages you send to our teachers, staff, community or support.",
              "যোগাযোগ: আমাদের শিক্ষক, কর্মী, কমিউনিটি বা সাপোর্টে পাঠানো বার্তা।",
            ],
          ]}
        />
      </Clause>

      <Clause n="2" title="How We Use Your Information" titleBn="আমরা কীভাবে তথ্য ব্যবহার করি">
        <BiList
          items={[
            ["To create and manage your account and provide the services you purchase.", "আপনার অ্যাকাউন্ট তৈরি ও পরিচালনা এবং ক্রয়কৃত সেবা প্রদানের জন্য।"],
            ["To process payments, enrolments, refunds and issue receipts.", "পেমেন্ট, ভর্তি, ফেরত প্রক্রিয়াকরণ ও রসিদ প্রদানের জন্য।"],
            ["To track learning progress and issue certificates.", "শিক্ষার অগ্রগতি পর্যবেক্ষণ ও সার্টিফিকেট প্রদানের জন্য।"],
            ["To provide support and respond to your requests.", "সহায়তা প্রদান ও আপনার অনুরোধে সাড়া দেওয়ার জন্য।"],
            ["To protect the Platform, prevent fraud and enforce our Terms.", "প্ল্যাটফর্ম সুরক্ষা, জালিয়াতি প্রতিরোধ ও শর্তাবলি বলবৎ করার জন্য।"],
            ["To send important service notices, and (with your consent) updates about courses.", "গুরুত্বপূর্ণ সেবা-নোটিশ এবং (আপনার সম্মতিতে) কোর্স সম্পর্কিত হালনাগাদ পাঠানোর জন্য।"],
            ["To comply with applicable laws of Bangladesh.", "বাংলাদেশের প্রযোজ্য আইন মেনে চলার জন্য।"],
          ]}
        />
      </Clause>

      <Clause n="3" title="Legal Basis & Consent" titleBn="আইনি ভিত্তি ও সম্মতি">
        <Bi
          en={
            <>
              We process your personal data on the basis of your consent, the performance of our
              contract with you (providing the services you purchase), our legitimate interest in
              operating a secure Platform, and compliance with legal obligations. By registering and
              using the Platform, you consent to the processing described in this policy. You may
              withdraw consent for non-essential processing at any time.
            </>
          }
          bn={
            <>
              আমরা আপনার সম্মতি, আপনার সাথে আমাদের চুক্তি সম্পাদন (ক্রয়কৃত সেবা প্রদান), নিরাপদ প্ল্যাটফর্ম
              পরিচালনার বৈধ স্বার্থ এবং আইনি বাধ্যবাধকতা পালনের ভিত্তিতে আপনার ব্যক্তিগত তথ্য প্রক্রিয়া করি।
              নিবন্ধন ও প্ল্যাটফর্ম ব্যবহারের মাধ্যমে আপনি এই নীতিমালায় বর্ণিত প্রক্রিয়াকরণে সম্মতি দিচ্ছেন। অপ্রয়োজনীয়
              প্রক্রিয়াকরণের সম্মতি আপনি যেকোনো সময় প্রত্যাহার করতে পারবেন।
            </>
          }
        />
      </Clause>

      <Clause n="4" title="Sharing of Information" titleBn="তথ্য শেয়ার করা">
        <Bi
          en={<>We do not sell your personal data. We share it only with:</>}
          bn={<>আমরা আপনার ব্যক্তিগত তথ্য বিক্রি করি না। আমরা কেবল নিম্নোক্তদের সাথে তা শেয়ার করি:</>}
        />
        <BiList
          items={[
            [
              "Payment providers (such as bKash) to process transactions and refunds.",
              "পেমেন্ট প্রদানকারী (যেমন বিকাশ) — লেনদেন ও ফেরত প্রক্রিয়াকরণের জন্য।",
            ],
            [
              "Trusted service providers (such as hosting, email and cloud storage) who act on our behalf under confidentiality obligations.",
              "বিশ্বস্ত সেবা-প্রদানকারী (যেমন হোস্টিং, ইমেইল ও ক্লাউড স্টোরেজ) — যারা গোপনীয়তার শর্তে আমাদের পক্ষে কাজ করে।",
            ],
            [
              "Government or regulatory authorities where required by the applicable laws of Bangladesh.",
              "সরকারি বা নিয়ন্ত্রক কর্তৃপক্ষ — বাংলাদেশের প্রযোজ্য আইনে প্রয়োজন হলে।",
            ],
          ]}
        />
      </Clause>

      <Clause n="5" title="Data Storage, Security & Retention" titleBn="তথ্য সংরক্ষণ, নিরাপত্তা ও ধারণকাল">
        <Bi
          en={
            <>
              We apply reasonable technical and organisational safeguards &mdash; including access
              controls, encryption in transit and short-lived signed links for protected media
              &mdash; to protect your data. Media and files are stored with a reputable cloud
              provider. We retain personal data only as long as needed to provide our services and to
              meet legal, accounting and dispute-resolution requirements, after which it is deleted or
              anonymised. No method of transmission or storage is completely secure, and we cannot
              guarantee absolute security.
            </>
          }
          bn={
            <>
              আপনার তথ্য সুরক্ষায় আমরা যুক্তিসংগত কারিগরি ও প্রাতিষ্ঠানিক ব্যবস্থা প্রয়োগ করি &mdash; যেমন
              অ্যাক্সেস নিয়ন্ত্রণ, ট্রানজিটে এনক্রিপশন ও সুরক্ষিত মিডিয়ার জন্য স্বল্পমেয়াদি সাইনড লিংক। মিডিয়া ও
              ফাইল একটি বিশ্বস্ত ক্লাউড প্রদানকারীর কাছে সংরক্ষিত হয়। আমরা কেবল সেবা প্রদান এবং আইনি, হিসাব ও
              বিরোধ-নিষ্পত্তির প্রয়োজন পর্যন্ত ব্যক্তিগত তথ্য সংরক্ষণ করি, এরপর তা মুছে বা বেনামি করা হয়। কোনো
              প্রেরণ বা সংরক্ষণ পদ্ধতিই সম্পূর্ণ নিরাপদ নয়, তাই আমরা পরম নিরাপত্তার নিশ্চয়তা দিতে পারি না।
            </>
          }
        />
      </Clause>

      <Clause n="6" title="Your Rights" titleBn="আপনার অধিকার">
        <Bi
          en={<>Subject to applicable law, you may:</>}
          bn={<>প্রযোজ্য আইন সাপেক্ষে আপনি পারেন:</>}
        />
        <BiList
          items={[
            ["Access the personal data we hold about you.", "আমাদের কাছে থাকা আপনার ব্যক্তিগত তথ্য জানতে।"],
            ["Request correction of inaccurate data.", "ভুল তথ্য সংশোধনের অনুরোধ করতে।"],
            ["Request deletion of your account and data, subject to legal retention needs.", "আইনি ধারণ প্রয়োজন সাপেক্ষে অ্যাকাউন্ট ও তথ্য মুছে ফেলার অনুরোধ করতে।"],
            ["Withdraw consent for optional communications.", "ঐচ্ছিক যোগাযোগের সম্মতি প্রত্যাহার করতে।"],
          ]}
        />
        <Bi
          en={<>To exercise any of these rights, contact us using the details below.</>}
          bn={<>এই অধিকারগুলো প্রয়োগ করতে নিচের তথ্য ব্যবহার করে আমাদের সাথে যোগাযোগ করুন।</>}
        />
      </Clause>

      <Clause n="7" title="Children's Privacy" titleBn="শিশুদের গোপনীয়তা">
        <Bi
          en={
            <>
              Where a student is under 18, a parent or legal guardian must register and provide
              consent on their behalf. We collect only the data needed to deliver the learning
              service and handle it with additional care.
            </>
          }
          bn={
            <>
              শিক্ষার্থীর বয়স ১৮ বছরের কম হলে অভিভাবককে তার পক্ষে নিবন্ধন ও সম্মতি প্রদান করতে হবে। আমরা কেবল
              শিক্ষা-সেবা প্রদানের জন্য প্রয়োজনীয় তথ্যই সংগ্রহ করি এবং তা অতিরিক্ত যত্নসহকারে পরিচালনা করি।
            </>
          }
        />
      </Clause>

      <Clause n="8" title="Cookies" titleBn="কুকিজ">
        <Bi
          en={
            <>
              We use cookies and similar technologies to keep you signed in and to improve the
              service. For details, see our{" "}
              <Link to="/cookie-policy" className="text-primary underline underline-offset-2">Cookie Policy</Link>.
            </>
          }
          bn={
            <>
              আপনাকে সাইন-ইন রাখতে ও সেবা উন্নত করতে আমরা কুকিজ ও অনুরূপ প্রযুক্তি ব্যবহার করি। বিস্তারিত জানতে
              আমাদের{" "}
              <Link to="/cookie-policy" className="text-primary underline underline-offset-2">কুকি নীতিমালা</Link> দেখুন।
            </>
          }
        />
      </Clause>

      <Clause n="9" title="Updates to This Policy" titleBn="নীতিমালার হালনাগাদ">
        <Bi
          en={
            <>
              We may update this Privacy Policy from time to time to reflect changes in our practices
              or the law, including Bangladesh&rsquo;s evolving data-protection framework. Material
              changes will be notified on the Platform. Continued use after an update constitutes
              acceptance of the revised policy.
            </>
          }
          bn={
            <>
              আমাদের কার্যপ্রণালি বা আইনের পরিবর্তন, বিশেষত বাংলাদেশের বিকাশমান তথ্য-সুরক্ষা কাঠামো প্রতিফলিত করতে
              আমরা সময়ে সময়ে এই প্রাইভেসি নীতিমালা হালনাগাদ করতে পারি। গুরুত্বপূর্ণ পরিবর্তন প্ল্যাটফর্মে জানানো হবে।
              হালনাগাদের পর ব্যবহার অব্যাহত রাখা সংশোধিত নীতিমালা গ্রহণ হিসেবে গণ্য হবে।
            </>
          }
        />
      </Clause>
    </LegalLayout>
  );
}
